import React, { useState } from 'react';

const BrandSelector = ({ brands, selectedBrand, onChange, onCreateBrand }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');

  const [saving, setSaving] = useState(false);

  const handleCreate = async () => {
    const trimmed = newBrandName.trim();
    if (!trimmed) return;
    if (brands.includes(trimmed)) {
      alert('Brand already exists');
      return;
    }
    setSaving(true);
    try {
      await onCreateBrand(trimmed);
      onChange(trimmed);
      setNewBrandName('');
      setIsCreating(false);
    } catch (error) {
      console.error('Error creating brand:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    if (value === '__create__') {
      setIsCreating(true);
    } else {
      onChange(value);
    }
  };

  if (isCreating) {
    return (
      <div className="flex gap-2">
        <input
          type="text"
          value={newBrandName}
          onChange={(e) => setNewBrandName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleCreate())}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="Enter new brand name"
          autoFocus
        />
        <button
          type="button"
          onClick={handleCreate}
          disabled={saving}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
        >
          {saving ? 'Adding...' : 'Add'}
        </button>
        <button
          type="button"
          onClick={() => { setIsCreating(false); setNewBrandName(''); }}
          className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
      </div>
    );
  }

  return (
    <select
      value={selectedBrand}
      onChange={handleSelectChange}
      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
    >
      <option value="">Select a brand...</option>
      {brands.map(brand => (
        <option key={brand} value={brand}>{brand}</option>
      ))}
      <option value="__create__">+ Create New Brand</option>
    </select>
  );
};

export default BrandSelector;
